import { c as _c } from "react/compiler-runtime";
interface MemeDropHeaderProps {
  readonly title: string;
}
export default function MemeDropHeader(t0) {
  const $ = _c(2);
  const {
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h3 className="tw-text-lg tw-font-semibold tw-text-iron-100 tw-mb-0">{title}</h3>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}